module.exports = __webpack_public_path__ + "static/media/signage-indoor-img46.14fc7bcb.jpg";